module.exports = __webpack_public_path__ + "img/padlock-icon.160f32f1.svg";